import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';

// Services
import { ClientTypeEditService } from '../../service/client-type-edit/client-type-edit.service';
import { LayoutProposta } from '../../../models/layout-proposta';

@Component({
	selector: 'app-client-type-edit',
	templateUrl: './client-type-edit.component.html',
	providers: [
		ClientTypeEditService,
		HttpModule
	]
})

export class ClientTypeEditComponent implements OnInit {
	clienttype: FormGroup;
	ID: string;
	Nome: string;
	Descricao: string;
	Valor: string;
	Ativo: boolean;
	UsuarioIDCriacao: string;
	DataCriacao: any;
	private token;
	private sub: any;
	public permissoes: any[] = [];
	public layoutProposta: LayoutProposta;

	constructor(fb: FormBuilder, private clienttypeEditService: ClientTypeEditService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.layoutProposta = new LayoutProposta();
		this.clienttype = fb.group({
			'ID': '',
			'Nome': ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
			'LayoutProposta' : [0,Validators.compose([Validators.min(1)])],
			'TipoSerasa' : ['',Validators.compose([Validators.min(1)])],
			'Valor': ['', Validators.compose([Validators.required, Validators.maxLength(18)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.clienttypeEditService.loadClientType(this.token, this.ID).subscribe(result => {
				var updateclienttype = result.Result;
				this.clienttype.setValue({
					ID: updateclienttype.ID,
					Nome: updateclienttype.Nome,
					LayoutProposta: updateclienttype.LayoutProposta,
					TipoSerasa:updateclienttype.TipoSerasa,
					Valor: updateclienttype.Valor,
					Ativo: updateclienttype.Ativo
				});
			})
		}, error => {
			console.log(error);

		});
	}

	editClientType(value: any) {
		console.log(value);
		this.clienttypeEditService.editClientType(this.token, value).subscribe(result => {
			if (result.Success)
				this.router.navigateByUrl('/tipo-cliente');

		}, error => {
			console.log(error);

		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/tipo-cliente');
	}

}



// WEBPACK FOOTER //
// ./src/app/client-type/component/client-type-edit/client-type-edit.component.ts